/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PendingEnrollmentRow } from './PendingEnrollmentRow';
import {
    PendingEnrollmentRowFromJSON,
    PendingEnrollmentRowFromJSONTyped,
    PendingEnrollmentRowToJSON,
    PendingEnrollmentRowToJSONTyped,
} from './PendingEnrollmentRow';

/**
 * 
 * @export
 * @interface WidgetDataRecentPendingEnrollmentsWidgetData
 */
export interface WidgetDataRecentPendingEnrollmentsWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataRecentPendingEnrollmentsWidgetData
     */
    $type?: WidgetDataRecentPendingEnrollmentsWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<PendingEnrollmentRow>}
     * @memberof WidgetDataRecentPendingEnrollmentsWidgetData
     */
    items: Array<PendingEnrollmentRow>;
}


/**
 * @export
 */
export const WidgetDataRecentPendingEnrollmentsWidgetDataTypeEnum = {
    PendingEnrollments: 'pending-enrollments'
} as const;
export type WidgetDataRecentPendingEnrollmentsWidgetDataTypeEnum = typeof WidgetDataRecentPendingEnrollmentsWidgetDataTypeEnum[keyof typeof WidgetDataRecentPendingEnrollmentsWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataRecentPendingEnrollmentsWidgetData interface.
 */
export function instanceOfWidgetDataRecentPendingEnrollmentsWidgetData(value: object): value is WidgetDataRecentPendingEnrollmentsWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataRecentPendingEnrollmentsWidgetDataFromJSON(json: any): WidgetDataRecentPendingEnrollmentsWidgetData {
    return WidgetDataRecentPendingEnrollmentsWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataRecentPendingEnrollmentsWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataRecentPendingEnrollmentsWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(PendingEnrollmentRowFromJSON)),
    };
}

export function WidgetDataRecentPendingEnrollmentsWidgetDataToJSON(json: any): WidgetDataRecentPendingEnrollmentsWidgetData {
    return WidgetDataRecentPendingEnrollmentsWidgetDataToJSONTyped(json, false);
}

export function WidgetDataRecentPendingEnrollmentsWidgetDataToJSONTyped(value?: WidgetDataRecentPendingEnrollmentsWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(PendingEnrollmentRowToJSON)),
    };
}

